/** @format */

import React, { useState, useEffect } from "react";
import LabelInput from "../../../shared/components/labelInput";
import { assetUrl } from "fusion-core";
import { useFormContext } from "react-hook-form";
import { fetchVehicleClaim } from "../../../shared/services/simpleListItemsService";
import Claim from "../../../shared/models/claimModel";
import { formatDateT, deformatDateT } from "../../../shared/utils/formatters";
import NewDatePicker from "../../../shared/components/newDatePicker";
import RadioGroup from "../../../shared/components/RadioGroup";

const TqAddDriverClaim = ({
  onClaimsUpdate,
  localClaimFields,
  setLocalClaimFields,
}) => {
  const {
    register,
    formState: { errors },
    watch,
    setValue,
    control,
    trigger,
  } = useFormContext();

  const [vClaim, setVClaim] = useState([]);
  const [editingClaimIndex, setEditingClaimIndex] = useState(null);
  const [openAddClaim, setOpenAddClaim] = useState(false);

  const trash = assetUrl("../../../assets/icons/trash-filled.svg");
  const pencil = assetUrl("../../../assets/icons/Group22.svg");
  const bars = assetUrl("../../../assets/icons/bars.svg");

  const today = new Date();
  const maxDate = new Date(today);

  useEffect(() => {
    fetchVehicleClaim().then((statuses) => setVClaim(statuses));
  }, []);

  const convertArrayFormat = (array) => {
    return array.map((item) => ({
      value: item.listItemId,
      label: item.listItemDescription,
    }));
  };

  const handleSaveClaim = async () => {
    const isValid = await trigger([
      "claimType",
      "AddClaim_Date",
      "claimCost",
      "Injured",
      "WhosFault",
    ]);

    if (isValid) {
      // Create new claim using the Claim model
      const newClaim = new Claim(
        watch("claimType").value, // typeId
        formatDateT(watch("AddClaim_Date")), // claimDate
        watch("claimCost"), // cost
        watch("WhosFault") === "Yes", // atFault
        watch("Injured") === "Yes", // injuryInvolved
        null, // objectId
        null, // claimDetailsId
        false, // theftFromHome
        null, // statusId
        false, // ncdAffected
        false, // incurredOnPolicy
        null, // referenceNumber
        null, // parentObjectId
        0 // parentObjectHistoryId
      );

      let updatedClaims;
      if (editingClaimIndex !== null) {
        updatedClaims = localClaimFields.map((claim, index) =>
          index === editingClaimIndex ? newClaim : claim
        );
      } else {
        updatedClaims = [...localClaimFields, newClaim];
      }

      setLocalClaimFields(updatedClaims);
      onClaimsUpdate(updatedClaims);

      // Reset form
      setValue("claimType", null);
      setValue("AddClaim_Date", null);
      setValue("claimCost", "");
      setValue("Injured", null);
      setValue("WhosFault", null);
      setValue("AddClaimButtonClicked", null);
      setEditingClaimIndex(null);
    }
  };

  const handleClaimEdit = (claim, index) => {
    setEditingClaimIndex(index);
    setValue("AddClaimButtonClicked", "Clicked");
    setValue("claimType", {
      value: claim.typeId,
    });
    setValue("AddClaim_Date", deformatDateT(claim.claimDate));
    setValue("claimCost", claim.cost);
    setValue("Injured", claim.injuryInvolved ? "Yes" : "No");
    setValue("WhosFault", claim.atFault ? "Yes" : "No");
  };

  const handleClaimDelete = (index) => {
    const updatedClaims = localClaimFields.filter((_, i) => i !== index);
    setLocalClaimFields(updatedClaims);
    onClaimsUpdate(updatedClaims);

    if (updatedClaims.length === 0) {
      setValue("AdditionalClaim", "No");
    }
  };

  const handleNoClaim = () => {
    setValue("AdditionalClaim", "No");
    setLocalClaimFields([]);
    onClaimsUpdate([]);
  };

  const closeAddClaimModel = () => {
    setValue("AddClaimButtonClicked", null);
    setEditingClaimIndex(null);
    // Reset form fields
    setValue("claimType", null);
    setValue("AddClaim_Date", null);
    setValue("claimCost", "");
    setValue("Injured", null);
    setValue("WhosFault", null);
  };

  const handleClaimModel = () => {
    if (localClaimFields.length < 5) {
      setValue("AddClaimButtonClicked", "Clicked");
      setValue("claimType", null);
      setValue("claimCost", null);
      setValue("Injured", null);
      setValue("WhosFault", null);
      setValue("AddClaim_Date", null);
    }
  };

  const OnChangeDate = (date) => {
    const formattedDate = `${String(date.getDate()).padStart(2, "0")}/${String(
      date.getMonth() + 1
    ).padStart(2, "0")}/${date.getFullYear()}`;

    setValue("AddClaim_Date", formattedDate);
    setTimeout(() => setOpenAddClaim(false), 100);
  };

  const remainningClaims = 5 - (localClaimFields?.length || 0);
  return (
    <>
      <RadioGroup
        name="AdditionalClaim"
        mainLabel="Have you had any accidents, losses, thefts, fire, flood or claims in any vehicle regardless of fault or whether you claimed or not in the last 5 years?"
        register={register}
        errors={errors.AdditionalClaim}
        onNo={handleNoClaim}
      />

      {watch("AdditionalClaim") === "Yes" && (
        <>
          {/* Claims list */}
          <div className="fields">
            <div className="driverFields">
              {localClaimFields.map((claim, index) => (
                <div className="addDriverDiv addDriverClaimDiv" key={index}>
                  <div className="divimgname2">
                    <img
                      className="imgDesign imgClaimDesign"
                      src={bars}
                      alt=""
                    />
                    <h2 className="divname">
                      {
                        convertArrayFormat(vClaim).find(
                          (value) => value.value == claim.typeId
                        )?.label
                      }
                    </h2>
                    <h2 className="divname">
                      {deformatDateT(claim.claimDate)}
                    </h2>
                  </div>
                  <div className="claimDateStyle"></div>
                  <div>
                    <button
                      type="button"
                      onClick={() => handleClaimEdit(claim, index)}
                      className="imgDim btnpencil"
                    >
                      <img className="imgDesign1" src={pencil} alt="" />
                    </button>
                    <button
                      type="button"
                      onClick={() => handleClaimDelete(index)}
                      className="imgDim"
                    >
                      <img className="imgDesign2" src={trash} alt="" />
                    </button>
                  </div>
                </div>
              ))}

              <div className="vertical-line">
                <div className="addDrivers">
                  <button
                    type="button"
                    className="lookupBtn bg-gray"
                    onClick={handleClaimModel}
                  >
                    <strong>Add a Claim</strong>
                  </button>
                </div>
                {remainningClaims === 0 && (
                  <p className="errorField claim-error">
                    Your Claim Limit is Reached
                  </p>
                )}
              </div>
            </div>
          </div>
        </>
      )}

      {watch("AddClaimButtonClicked") === "Clicked" &&
        watch("AdditionalClaim") === "Yes" && (
          <div className="addClaimDiv">
            <span onClick={closeAddClaimModel} className="closeClaimModel">
              &times;
            </span>
            <LabelInput
              id="claimType"
              label="What type of claim occurred?"
              type="select"
              options={convertArrayFormat(vClaim)}
              control={control}
              placeholder="Select claim"
              register={register("claimType", { required: true })}
              errors={errors.claimType}
              watch={watch("claimType")}
              trigger={trigger}
            />
            <NewDatePicker
              name="AddClaim_Date"
              label="What date did the incident occur?"
              errors={errors.AddClaim_Date}
              setValue={setValue}
              control={control}
              trigger={trigger}
              rules={{
                required: "Date is required",
              }}
              watch={watch}
              maxDate={new Date()}
            />
            <LabelInput
              id="claimCost"
              label="What is the current cost of the claim?"
              type="number"
              placeholder="e.g. 7,000"
              pattern="[0-9]*"
              register={register("claimCost", {
                required: "This field is required",
              })}
              errors={errors.claimCost}
              watch={watch("claimCost")}
              trigger={trigger}
            />

            <RadioGroup
              name="Injured"
              mainLabel="Was anyone injured in the incident?"
              register={register}
              errors={errors.Injured}
            />

            <RadioGroup
              name="WhosFault"
              mainLabel="Were you at fault?"
              secondaryLabel="A fault claim is where your insurance company paid out for
                    any part of the claim. A non-fault claim is where all costs
                    are recovered from a third party."
              register={register}
              errors={errors.WhosFault}
            />

            <div className="saveDetails">
              <button
                type="button"
                className="claimSaveBtn"
                onClick={handleSaveClaim}
              >
                Save Claim
              </button>
            </div>
          </div>
        )}
    </>
  );
};

export default TqAddDriverClaim;
